module.exports = __webpack_public_path__ + "static/example-image-3-468ae9793abef96f26ac2d280afe9a94.jpg";